"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { floorPlanDetail } from "../../../../public/images/logos";

const AdditionalInfo = () => {
  const t = useTranslations("threeSixtyService.additionalInfo");
  const tC = useTranslations("common");

  return (
    <div className="gs--page-column py-16">
      <FeatureHighlight
        src={floorPlanDetail}
        alt={"Grundriss Detail Icon der Grundriss Schmiede"}
        title={t("title")}
        text={t("text")}
        subText={t("text2")}
        subText2={t("text3")}
        list={[tC("floorPlan"), tC("dollHouseView"), tC("threeSixtyTour")]}
      />
    </div>
  );
};

export default AdditionalInfo;
